import React from "react";
import { useHistory, Route } from "react-router-dom";
export const AuthRoute = (props) => {
  const router = useHistory();
  React.useEffect(() => {
    async function fetchData() {
      try {
        await props.Auth.currentAuthenticatedUser();
        router.push("/");
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [router]);
  return <Route {...props} />;
};
